import { Form, Row, Col, Space, Card, Typography, message, Radio, Select, Checkbox, Alert } from "antd";
import { AntdButton, CheckboxField, InputField, SelectInput, TextareaField } from "../../../blueplanitUtils/InputField";
import { useEffect, useRef, useState } from "react";
import { ADD_EDIT_EMPLOYEE, BASIC_INFO, EMPLOYEE_DEPARTMENT, EMPLOYMENT_TYPE, WORK_TYPE } from "../../../Dropdownmanager";
import { getOptionsByPath } from "../../../utilsdata";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { getSingleJobRequisitionAsync, updateJobRequisitionAsync } from "../../../Slices/hiringSlice";
import { submitRefreshPage } from "../../../Slices/orderSlice";
import Swal from "sweetalert2";
import RichTextEditor from "../../../blueplanitUtils/RichTextEditor";

const JobRequisitionDetails = () => {
    const { id } = useParams();
    const descriptionRef = useRef();
    const responsibilitiesRef = useRef();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);
    const jobRequisition = useSelector((state) => state.hiring.singleJob);

    const details = useSelector((state) => state.employee.AllEmployees);

    useEffect(() => {
        if (id) {
            dispatch(getSingleJobRequisitionAsync(id))
        }
    }, [dispatch, id]);

    const [formData, setFormData] = useState({
        requisitionId: "",
        designation: "",
        dept: "",
        assignedTo: "",
        location: "",
        employmentType: "",
        workMode: "",
        numberOfOpenings: "",
        experienceRequired: "",
        skillsRequired: [],
        jobDescription: "",
        jobResponsibilities: "",
        salaryRange: "",
        shift: "",
        reasonForHiring: "",
        notes: "",
        applyUrl: "",
        approvalStatus: "Pending",
        hasQuestions: "No",   // ✅ NEW
        questions: [],
        hasInterviewQuestions: "No",
        interviewQuestions: [],
        hasExam: "No",
        exam: {
            enabled: false,
            examTitle: "",
            examLink: "",
            durationInMinutes: 45,
            instructions: "",
            passingScore: "",
            questions: []
        }
    });

    const addQuestion = () => {
        setFormData(prev => ({
            ...prev,
            questions: [
                ...prev.questions,
                {
                    id: `q_${Date.now()}`,
                    label: "",
                    type: "input",
                    options: [],
                    required: true
                }
            ]
        }));
    };



    const updateQuestion = (index, field, value) => {
        setFormData((prev) => {
            const questions = [...prev.questions];

            questions[index] = {
                ...questions[index],
                [field]: value
            };

            if (
                field === "type" &&
                !["radio", "checkbox", "select"].includes(value)
            ) {
                questions[index].options = [];
            }

            return {
                ...prev,
                questions
            };
        });
    };


    const addOption = (qIndex) => {
        setFormData((prev) => {
            const questions = [...prev.questions];
            questions[qIndex].options = [...questions[qIndex].options, ""];
            return { ...prev, questions };
        });
    };

    const updateOption = (qIndex, optIndex, value) => {
        setFormData((prev) => {
            const questions = [...prev.questions];
            const options = [...questions[qIndex].options];
            options[optIndex] = value;
            questions[qIndex].options = options;
            return { ...prev, questions };
        });
    };


    const removeOption = (qIndex, optIndex) => {
        setFormData((prev) => {
            const questions = [...prev.questions];
            questions[qIndex].options = questions[qIndex].options.filter(
                (_, i) => i !== optIndex
            );
            return { ...prev, questions };
        });
    };


    const removeQuestion = (index) => {
        setFormData((prev) => ({
            ...prev,
            questions: prev.questions.filter((_, i) => i !== index)
        }));
    };

    const handleChange = (name, value) => {
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const addInterviewQuestion = () => {
        setFormData(prev => ({
            ...prev,
            interviewQuestions: [
                ...prev.interviewQuestions,
                {
                    question: "",
                    category: "Technical",
                    required: true
                }
            ]
        }));
    };

    const updateInterviewQuestion = (index, field, value) => {
        const updated = [...formData.interviewQuestions];
        updated[index][field] = value;
        setFormData({ ...formData, interviewQuestions: updated });
    };

    const removeInterviewQuestion = (index) => {
        const updated = [...formData.interviewQuestions];
        updated.splice(index, 1);
        setFormData({ ...formData, interviewQuestions: updated });
    };

    // Add a new blank exam question
    const addExamQuestion = () => {
        handleExamChange("questions", [
            ...formData.exam.questions,
            {
                questionText: "",
                type: "text",
                options: []
            }
        ]);
    };


    // Update a question at index
    const updateExamQuestion = (index, field, value) => {
        const updatedQuestions = [...formData.exam.questions];
        updatedQuestions[index] = {
            ...updatedQuestions[index],
            [field]: value
        };

        handleExamChange("questions", updatedQuestions);
    };


    // Remove a question
    const removeExamQuestion = (index) => {
        const updatedQuestions = formData.exam.questions.filter((_, i) => i !== index);
        handleExamChange("questions", updatedQuestions);
    };

    useEffect(() => {
        if (jobRequisition) {
            setFormData({
                requisitionId: jobRequisition.requisitionId,
                designation: jobRequisition.designation || "",
                dept: jobRequisition.dept || "",
                assignedTo: jobRequisition.assignedTo || "",
                numberOfOpenings: jobRequisition.numberOfOpenings || "",
                employmentType: jobRequisition.employmentType || "",
                experienceRequired: jobRequisition.experienceRequired || "",
                workMode: jobRequisition.workMode || "",
                skillsRequired: (jobRequisition.skillsRequired || []).join(", "),  // convert array → comma text
                salaryRange: jobRequisition.salaryRange || "",
                shift: jobRequisition.shift || "",
                location: jobRequisition.location || "",
                reasonForHiring: jobRequisition.reasonForHiring || "",
                jobDescription: jobRequisition.jobDescription || "",
                jobResponsibilities: jobRequisition.jobResponsibilities || "",
                notes: jobRequisition.notes || "",
                applyUrl: jobRequisition.applyUrl,
                hasQuestions: jobRequisition?.questions?.length > 0 ? "Yes" : "No",
                questions: (jobRequisition?.questions || []).map((q) => ({
                    id: q.id,
                    type: q.type,
                    label: q.label,
                    options: q.options || [],
                    required: q.required
                })),
                hasInterviewQuestions: jobRequisition?.interviewQuestions?.length > 0 ? "Yes" : "No",
                interviewQuestions: (jobRequisition.interviewQuestions || []).map((q) => ({
                    questionId: q.questionId,
                    question: q.question,
                    category: q.category,
                    required: q.required
                })),
                hasExam: jobRequisition?.exam?.enabled ? "Yes" : "No",
                exam: {
                    examTitle: jobRequisition?.exam?.examTitle || "",
                    durationInMinutes: jobRequisition?.exam?.durationInMinutes || "",
                    passingScore: jobRequisition?.exam?.passingScore || "",
                    instructions: jobRequisition?.exam?.instructions || "",
                    examLink: jobRequisition?.exam?.examLink || "",
                    questions: jobRequisition?.exam?.questions || []
                }

            })
        }
    }, [jobRequisition])

    const handleSubmit = async () => {
        try {
            const skillsArray = formData.skillsRequired
                ? formData.skillsRequired.split(",").map(s => s.trim())
                : [];

            const payload = {
                designation: formData.designation,
                dept: formData.dept,
                assignedTo: formData.assignedTo,
                numberOfOpenings: Number(formData.numberOfOpenings),
                employmentType: formData.employmentType,
                experienceRequired: formData.experienceRequired,
                workMode: formData.workMode,
                skillsRequired: skillsArray,
                salaryRange: formData.salaryRange,
                shift: formData.shift,
                location: formData.location,
                reasonForHiring: formData.reasonForHiring,
                jobDescription: formData.jobDescription,
                jobResponsibilities: formData.jobResponsibilities,
                notes: formData.notes,
                questions: formData.hasQuestions === "Yes"
                    ? formData.questions.map((q) => ({
                        id: q.id,
                        type: q.type,
                        label: q.label,
                        options: q.options || [],
                        required: q.required
                    }))
                    : [],
                interviewQuestions: formData.hasInterviewQuestions === "Yes" ?
                    formData.interviewQuestions.map((q) => ({
                        questionId: q.questionId,
                        question: q.question,
                        category: q.category,
                        required: q.required

                    }))
                    : [],
                exam:
                    formData.hasExam === "Yes"
                        ? {
                            enabled: true,
                            examTitle: formData.exam.examTitle,
                            examLink: formData.exam.examLink,
                            durationInMinutes: Number(formData.exam.durationInMinutes),
                            instructions: formData.exam.instructions,
                            passingScore: Number(formData.exam.passingScore),
                            questions: formData.exam.questions.map(q => ({
                                questionText: q.questionText,
                                type: q.type,
                                options: q.type === "mcq" ? q.options : []
                            }))
                        }
                        : { enabled: false },

            };
            const original = jobRequisition || {};

            const isChanged = Object.keys(payload).some((key) => {
                if (Array.isArray(payload[key])) {
                    return payload[key].join(",") !== (original[key] || []).join(",");
                }
                return String(payload[key]) !== String(original[key] || "");
            });

            if (!isChanged) {
                message.warning("No changes were made.");
                return;
            }

            const confirm = await Swal.fire({
                title: "Confirm Update",
                text: "Are you sure you want to update this job requisition?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, Update",
                cancelButtonText: "Cancel",
            });

            if (!confirm.isConfirmed) return;
            const response = await dispatch(
                updateJobRequisitionAsync({ id, data: payload })
            ).unwrap();

            message.success({
                content: response.message || "Job Requisition Updated Successfully",
                duration: 2,
                className: "custom-toast-center"
            });


        } catch (error) {
            message.error(
                error?.message || "Something went wrong while updating job requisition."
            );
            console.error("Update Error:", error);
        }
    };

    const cancelHandelar = () => {
        dispatch(submitRefreshPage(false))
        navigate("/JobRequisition");
    };

    const assignedToOptions = details.map((emp) => ({
        label: emp.firstname + " " + emp.lastname,
        value: emp.id,
    }));

    const handleExamChange = (key, value) => {
        setFormData(prev => ({
            ...prev,
            exam: {
                ...prev.exam,
                [key]: value
            }
        }));
    };

    const generateExamLink = () => {
        const { examTitle, durationInMinutes, questions } = formData.exam;

        if (!examTitle || !durationInMinutes || !questions.length) {
            message.error(
                "Please enter exam title, duration, and at least one question before generating the link"
            );
            return;
        }
        const randomId = Math.random().toString(36).substring(2, 8).toUpperCase();
        const examId = `EXAM-${randomId}`;
        const baseUrl = "https://blueplanitcorp.com/online-exam.html";

        const generatedLink = `${baseUrl}?examId=${examId}`;

        handleExamChange("examId", examId);
        handleExamChange("examLink", generatedLink);

        message.success("Exam link generated successfully!");
    };


    return (
        <div style={{ width: "100%", marginBottom: "5px" }}>
            <Form layout='vertical' onFinish={handleSubmit}>
                <Row justify="end" gutter={16} style={{ marginBottom: "7px" }}>
                    <Col span={24} style={{ marginTop: 16, textAlign: "left" }}>
                        <Space>
                            <AntdButton label="Save" color='primary' variant='solid' htmlType="submit" />

                            <AntdButton label="Cancel" color='danger' variant='solid' onClick={cancelHandelar} />

                        </Space>
                    </Col>
                </Row>
                <Card
                    style={{ marginBottom: "12px" }}
                    title={
                        <Space
                            direction="horizontal"
                            style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "space-between",
                            }}
                        >
                            <Typography.Title
                                level={5}
                                style={{ marginBottom: 0, fontWeight: "bold" }}
                            >
                                Job Requisition Details
                            </Typography.Title>
                        </Space>
                    }
                >
                    <Row gutter={[16, 16]}>

                        <Col span={4}>
                            <Form.Item label="Requisition ID" name="requisitionId">
                                <Typography.Text strong>{formData.requisitionId}</Typography.Text>
                            </Form.Item>
                        </Col>

                        <Col span={4}>
                            <InputField
                                label="Designation"
                                name="designation"
                                value={formData.designation}
                                onChange={(e) => handleChange("designation", e.target.value)}
                                placeholder="Enter Job Title"
                            />
                        </Col>

                        <Col span={4}>
                            <SelectInput
                                label="Department"
                                name="dept"
                                value={formData.dept}
                                onChange={(value) => handleChange("dept", value)}
                                placeholder="Select Department"
                                style={{ width: '100%' }}
                                options={getOptionsByPath(NestedDatabucket, [ADD_EDIT_EMPLOYEE, EMPLOYEE_DEPARTMENT])}
                            />
                        </Col>
                        <Col span={4}>
                            <SelectInput
                                label="Assigned To"
                                name="assignedTo"
                                value={formData.assignedTo}
                                onChange={(value) => handleChange("assignedTo", value)}
                                style={{ width: "100%" }}
                                options={assignedToOptions}
                                placeholder="Select AssignedTo"

                            />
                        </Col>

                        <Col span={4}>
                            <InputField
                                label="Number of Openings"
                                name="openings"
                                type="number"
                                value={formData.numberOfOpenings}
                                onChange={(e) => handleChange("numberOfOpenings", e.target.value)}
                                placeholder="Enter Number of Openings"
                            />
                        </Col>

                        <Col span={4}>
                            <SelectInput
                                label="Employment Type"
                                name="employmentType"
                                value={formData.employmentType}
                                onChange={(value) => handleChange("employmentType", value)}
                                placeholder="Select Employment Type"
                                style={{ width: '100%' }}
                                options={getOptionsByPath(NestedDatabucket, [BASIC_INFO, EMPLOYMENT_TYPE])}
                            />
                        </Col>

                        <Col span={4}>
                            <InputField
                                label="Experience Required"
                                name="experience"
                                value={formData.experienceRequired}
                                onChange={(e) => handleChange("experienceRequired", e.target.value)}
                                placeholder="Enter Experience Required"
                            />
                        </Col>

                        <Col span={4}>
                            <SelectInput
                                label="Work Mode"
                                name="workMode"
                                value={formData.workMode}
                                onChange={(value) => handleChange("workMode", value)}
                                style={{ width: '100%' }}
                                placeholder="Select Work Mode"
                                options={getOptionsByPath(NestedDatabucket, [BASIC_INFO, WORK_TYPE])}

                            // options={["Onsite", "Hybrid", "Remote"]}
                            />
                        </Col>

                        <Col span={4}>
                            <InputField
                                label="Skills Required"
                                name="skills"
                                type="tags"
                                value={formData.skillsRequired}
                                onChange={(e) => handleChange("skillsRequired", e.target.value)}
                                placeholder="Add required skills"
                            />
                        </Col>

                        <Col span={4}>
                            <InputField
                                label="Budget Range"
                                name="budgetRange"
                                value={formData.salaryRange}
                                onChange={(e) => handleChange("salaryRange", e.target.value)}
                                placeholder="e.g., 4-7 LPA"
                            />
                        </Col>

                        <Col span={4}>
                            <SelectInput
                                label="Shift"
                                name="shift"
                                style={{ width: '100%' }}
                                value={formData.shift}
                                onChange={(value) => handleChange("shift", value)}
                                placeholder="Select Shift Type"
                                options={[
                                    { label: "General", value: "General" },
                                    { label: "Morning", value: "Morning" },
                                    { label: "Evening", value: "Evening" },
                                    { label: "Night", value: "Night" },
                                    { label: "Rotational", value: "Rotational" }
                                ]}
                            />
                        </Col>

                        <Col span={4}>
                            <InputField
                                label="Location"
                                name="location"
                                value={formData.location}
                                onChange={(e) => handleChange("location", e.target.value)}
                                placeholder="Enter Job Location"
                            />
                        </Col>

                        <Col span={24}>
                            <RichTextEditor
                                label="Job Description"
                                ref={descriptionRef}
                                value={formData.jobDescription}
                                onChange={(value) => handleChange("jobDescription", value)}
                            />
                        </Col>

                        <Col span={24}>
                            <RichTextEditor
                                label="Job Responsibilities"
                                ref={responsibilitiesRef}
                                value={formData.jobResponsibilities}
                                onChange={(value) => handleChange("jobResponsibilities", value)}
                                placeholder="Enter responsibilities"
                            />
                        </Col>
                        <Col span={6}>
                            <Form.Item label="Questions">
                                <Radio.Group
                                    value={formData.hasQuestions}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        handleChange("hasQuestions", value);
                                        if (value === "No") {
                                            handleChange("questions", []);
                                        }
                                    }}
                                >
                                    <Radio value="Yes">Yes</Radio>
                                    <Radio value="No">No</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>

                        {formData.hasQuestions === "Yes" && (
                            <Col span={24}>
                                <Card
                                    size="small"
                                    extra={
                                        <AntdButton
                                            label="Add Question"
                                            color="primary"
                                            variant="outlined"
                                            onClick={addQuestion}
                                        />
                                    }
                                >
                                    {formData.questions.length === 0 && (
                                        <p style={{ color: "#999" }}>No questions added yet.</p>
                                    )}

                                    {formData.questions.map((q, index) => (
                                        <Card key={q.id} size="small" style={{ marginBottom: 12 }}>
                                            <Row gutter={8}>
                                                <Col span={14}>
                                                    <InputField
                                                        placeholder={`Question ${index + 1}`}
                                                        value={q.label}
                                                        onChange={(e) => updateQuestion(index, "label", e.target.value)}
                                                    />
                                                </Col>

                                                <Col span={5}>
                                                    <Select
                                                        value={q.type}
                                                        style={{ width: "100%" }}
                                                        onChange={(value) => updateQuestion(index, "type", value)}
                                                        options={[
                                                            { label: "Input", value: "input" },
                                                            { label: "Textarea", value: "textarea" },
                                                            { label: "Radio", value: "radio" },
                                                            { label: "Checkbox", value: "checkbox" },
                                                            { label: "Dropdown", value: "select" }
                                                        ]}
                                                    />
                                                </Col>

                                                <Col span={3}>
                                                    <Checkbox
                                                        checked={q.required}
                                                        onChange={(e) =>
                                                            updateQuestion(index, "required", e.target.checked)
                                                        }
                                                    >
                                                        Required
                                                    </Checkbox>
                                                </Col>

                                                <Col span={2}>
                                                    <AntdButton
                                                        label="✕"
                                                        color="danger"
                                                        variant="outlined"
                                                        onClick={() => removeQuestion(index)}
                                                    />
                                                </Col>
                                            </Row>

                                            {/* OPTIONS */}
                                            {["radio", "checkbox", "select"].includes(q.type) && (
                                                <div style={{ marginTop: 10 }}>
                                                    <b>Options</b>
                                                    {q.options.map((opt, optIndex) => (
                                                        <Row key={optIndex} gutter={8} style={{ marginTop: 6 }}>
                                                            <Col span={20}>
                                                                <InputField
                                                                    placeholder={`Option ${optIndex + 1}`}
                                                                    value={opt}
                                                                    onChange={(e) =>
                                                                        updateOption(index, optIndex, e.target.value)
                                                                    }
                                                                />
                                                            </Col>
                                                            <Col span={4}>
                                                                <AntdButton
                                                                    label="✕"
                                                                    color="danger"
                                                                    variant="outlined"
                                                                    onClick={() => removeOption(index, optIndex)}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    ))}

                                                    <AntdButton
                                                        label="Add Option"
                                                        variant="outlined"
                                                        onClick={() => addOption(index)}
                                                        style={{ marginTop: 8 }}
                                                    />
                                                </div>
                                            )}
                                        </Card>
                                    ))}
                                </Card>
                            </Col>
                        )}

                        <Col span={24}>
                            <Form.Item label="Interview Questions">
                                <Radio.Group
                                    value={formData.hasInterviewQuestions}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        handleChange("hasInterviewQuestions", value);
                                        if (value === "No") {
                                            handleChange("interviewQuestions", []);
                                        }
                                    }}
                                >
                                    <Radio value="Yes">Yes</Radio>
                                    <Radio value="No">No</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>

                        {formData.hasInterviewQuestions === "Yes" && (
                            <Col span={24}>
                                <SelectInput
                                    label="Select Department"
                                    value={formData.dept}
                                    onChange={(value) => handleChange("dept", value)}
                                    placeholder="Select Department"
                                    options={getOptionsByPath(NestedDatabucket, [ADD_EDIT_EMPLOYEE, EMPLOYEE_DEPARTMENT])}
                                />
                            </Col>
                        )}

                        {formData.hasInterviewQuestions === "Yes" && formData.dept && (
                            <Col span={24}>
                                <Card
                                    size="small"
                                    extra={
                                        <AntdButton
                                            label="Add Interview Question"
                                            color="primary"
                                            variant="outlined"
                                            onClick={addInterviewQuestion}
                                        />
                                    }
                                >
                                    {formData.interviewQuestions.length === 0 && (
                                        <p style={{ color: "#999" }}>No interview questions added yet.</p>
                                    )}

                                    {formData.interviewQuestions.map((q, index) => (
                                        <Card
                                            key={index}
                                            size="small"
                                            style={{ marginBottom: 12 }}
                                        >
                                            <Row gutter={8}>
                                                <Col span={14}>
                                                    <InputField
                                                        placeholder={`Interview Question ${index + 1}`}
                                                        value={q.question}
                                                        onChange={(e) =>
                                                            updateInterviewQuestion(index, "question", e.target.value)
                                                        }
                                                    />
                                                </Col>

                                                <Col span={6}>
                                                    <SelectInput
                                                        value={q.category}
                                                        style={{ width: "100%" }}
                                                        onChange={(value) =>
                                                            updateInterviewQuestion(index, "category", value)
                                                        }
                                                        options={[
                                                            { label: "Technical", value: "Technical" },
                                                            { label: "HR", value: "HR" },
                                                            { label: "Behavioral", value: "Behavioral" },
                                                            { label: "Managerial", value: "Managerial" }
                                                        ]}
                                                    />
                                                </Col>

                                                <Col span={3}>
                                                    <CheckboxField
                                                        label="Required"
                                                        checked={q.required}
                                                        onChange={(e) =>
                                                            updateInterviewQuestion(index, "required", e.target.checked)
                                                        }
                                                    />
                                                </Col>

                                                <Col span={1}>
                                                    <AntdButton
                                                        label="✕"
                                                        color="danger"
                                                        variant="outlined"
                                                        onClick={() => removeInterviewQuestion(index)}
                                                    />
                                                </Col>
                                            </Row>
                                        </Card>
                                    ))}
                                </Card>
                            </Col>
                        )}
                        {formData.hasExam === "Yes" && formData.exam && (
                            <Col span={24}>
                                <Card
                                    size="small"
                                    title="Exam Details"
                                    extra={
                                        <AntdButton
                                            label="Generate Exam Link"
                                            color="primary"
                                            variant="outlined"
                                            onClick={generateExamLink}
                                        />
                                    }
                                >
                                    {/* Exam Meta */}
                                    <Row gutter={12} style={{ marginBottom: 12 }}>
                                        <Col span={12}>
                                            <InputField
                                                placeholder="Exam Title"
                                                value={formData.exam.examTitle}
                                                onChange={(e) => handleExamChange("examTitle", e.target.value)}
                                            />
                                        </Col>
                                        <Col span={6}>
                                            <InputField
                                                type="number"
                                                placeholder="Duration (minutes)"
                                                value={formData.exam.durationInMinutes}
                                                onChange={(e) => handleExamChange("durationInMinutes", e.target.value)}
                                            />
                                        </Col>
                                        <Col span={6}>
                                            <InputField
                                                type="number"
                                                placeholder="Passing Score (%)"
                                                value={formData.exam.passingScore}
                                                onChange={(e) => handleExamChange("passingScore", e.target.value)}
                                            />
                                        </Col>
                                    </Row>

                                    <Row style={{ marginBottom: 12 }}>
                                        <Col span={24}>
                                            <TextareaField
                                                rows={3}
                                                placeholder="Instructions"
                                                value={formData.exam.instructions}
                                                onChange={(e) => handleExamChange("instructions", e.target.value)}
                                            />
                                        </Col>
                                    </Row>

                                    {/* Exam Link */}
                                    {formData.exam.examLink && (
                                        <Alert
                                            type="success"
                                            showIcon
                                            message="Exam Link Generated"
                                            description={
                                                <a href={formData.exam.examLink} target="_blank" rel="noopener noreferrer">
                                                    {formData.exam.examLink}
                                                </a>
                                            }
                                            style={{ marginBottom: 16 }}
                                        />
                                    )}

                                    {/* Questions */}
                                    {formData.exam.questions.map((q, index) => (
                                        <Card key={index} size="small" style={{ marginBottom: 12 }}>
                                            <Row gutter={12}>
                                                <Col span={24}>
                                                    <InputField
                                                        placeholder={`Question ${index + 1}`}
                                                        value={q.questionText}
                                                        onChange={(e) =>
                                                            updateExamQuestion(index, "questionText", e.target.value)
                                                        }
                                                    />
                                                </Col>

                                                <Col span={8} style={{ marginTop: 8 }}>
                                                    <SelectInput
                                                        value={q.type}
                                                        options={[
                                                            { label: "text", value: "text" },
                                                            { label: "mcq", value: "mcq" }
                                                        ]}
                                                        onChange={(value) => {
                                                            updateExamQuestion(index, "type", value);
                                                            updateExamQuestion(index, "options", value === "mcq" ? ["", "", "", ""] : []);
                                                        }}
                                                    />
                                                </Col>

                                                {/* MCQ Options */}
                                                {q.type === "mcq" && (
                                                    <Col span={24} style={{ marginTop: 8 }}>
                                                        {q.options.map((opt, i) => (
                                                            <InputField
                                                                key={i}
                                                                placeholder={`Option ${i + 1}`}
                                                                value={opt}
                                                                style={{ marginBottom: 6 }}
                                                                onChange={(e) => {
                                                                    const newOptions = [...q.options];
                                                                    newOptions[i] = e.target.value;
                                                                    updateExamQuestion(index, "options", newOptions);
                                                                }}
                                                            />
                                                        ))}
                                                    </Col>
                                                )}

                                                <Col span={24} style={{ textAlign: "right", marginTop: 8 }}>
                                                    <AntdButton
                                                        label="Remove Question"
                                                        color="danger"
                                                        variant="outlined"
                                                        onClick={() => removeExamQuestion(index)}
                                                    />
                                                </Col>
                                            </Row>
                                        </Card>
                                    ))}

                                    {/* Add Question */}
                                    <Row>
                                        <Col span={24} style={{ textAlign: "right" }}>
                                            <AntdButton
                                                label="Add Question"
                                                color="primary"
                                                variant="outlined"
                                                onClick={addExamQuestion}
                                            />
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        )}

                        {/* {formData.exam.examLink && (
                            <Row style={{ marginTop: 12 }}>
                                <Col span={24}>
                                    <Alert
                                        type="success"
                                        showIcon
                                        message="Exam Link Generated"
                                        description={
                                            <a href={formData.exam.examLink} target="_blank" rel="noopener noreferrer">
                                                {formData.exam.examLink}
                                            </a>
                                        }
                                    />
                                </Col>
                            </Row>
                        )} */}

                        <Col span={24}>
                            <TextareaField
                                label="Additional Notes"
                                name="notes"
                                value={formData.notes}
                                onChange={(e) => handleChange("notes", e.target.value)}
                                rows={3}
                                placeholder="Write any additional info"
                            />
                        </Col>
                    </Row>
                </Card>

            </Form>
        </div>
    )
};

export default JobRequisitionDetails;